import { AnimatePresence, motion } from "framer-motion";
import { useRef } from "react";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import * as action from "../../Store/_redux/LeaveStore/leaveAction";
import moment from "moment";
import { useState } from "react";
import { editUser } from "../../Store/_redux/UserStore/userCrud";
export default function UserEditModal({ isOpen, onClose, user, refresh }) {
  const dispatch = useDispatch();
  const leaveChangeRef = useRef();
  const [name, setName] = useState(user.name || "");
  const [surname, setSurname] = useState(user.surname || "");
  const [birthDay, setBirthDay] = useState(
    user.birthDay ? moment(user.birthDay).format("YYYY-MM-DD") : ""
  );
  const [isAdmin, setIsAdmin] = useState(user.userType === "admin");

  const handleClose = () => {
    if (leaveChangeRef.current) leaveChangeRef.current.value = "";
    onClose();
  };
  const handleSave = async () => {
    // Yalnızca düzenlenen profil alanları gönderilir; bakiye alanları bu formdan değişmez
    const profileUpdate = {
      name,
      surname,
      birthDay: birthDay || null,
      userType: isAdmin ? "admin" : "user",
    };

    try {
      await editUser(user._id, profileUpdate);
    } catch (error) {
      toast.error("Kullanıcı bilgileri güncellenemedi");
      return;
    }

    // Yalnızca gerçekten bir izin değişikliği girildiyse izin işlemi oluştur
    const value = Number(leaveChangeRef.current?.value) || 0;
    if (value !== 0 && !(await dispatch(action.systemLeaveAction({ value, tc: user.tc })))) {
      toast.error("Kullanıcı bilgileri güncellendi ancak izin günü değişikliği kaydedilemedi");
      await refresh();
      return;
    }

    toast.success("Kullanıcı bilgileri güncellendi");
    await refresh();
    handleClose();
  };
  if (!isOpen) return null;

  return (
    <AnimatePresence>
      <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-20">
        <motion.div
          initial={{ opacity: 0, scale: 0.95 }}
          animate={{ opacity: 1, scale: 1 }}
          exit={{ opacity: 0, scale: 0.95 }}
          transition={{ duration: 0.2 }}
          className="bg-white p-6 rounded-2xl max-w-xl w-full shadow-2xl relative border border-gray-200"
        >
          <h1 className="text-2xl font-bold mb-4">Kullanıcı Bilgi</h1>
          <h2 className="text-l font-light  mb-4">Düzenlemek için düzenlemek istediğiniz değerin üzerine tıklayınız.</h2>

          <div className="space-y-2">
            <p><strong>Ad:</strong> <input type="text" defaultValue={user.name} onChange={(e) => setName(e.target.value)}/></p>
            <p><strong>Soyad:</strong> <input type="text" defaultValue={user.surname} onChange={(e) => setSurname(e.target.value)}/></p>
            <p><strong>TC:</strong> {user.tc}</p>
            <p><strong>Mevcut İzin:</strong> {user.remainingLeaveDays} gün</p>
            <p><strong>Doğum Günü:</strong> <input type="date" value={birthDay} onChange={(e) => setBirthDay(e.target.value)}/></p>
            <label className="flex items-center gap-2 pt-2">
              <input
                type="checkbox"
                checked={isAdmin}
                onChange={(e) => setIsAdmin(e.target.checked)}
                className="w-4 h-4"
              />
              <strong>Yönetici (admin) yetkisi</strong>
            </label>
          </div>

          <div className="mt-4">
            <label className="block mb-1 font-semibold">Eklenecek / Çıkarılacak Gün</label>
            <input
              defaultValue={0}
              type="number"
              ref={leaveChangeRef}
              className="border border-gray-300 px-3 py-2 rounded-lg w-full text-center shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-400 focus:border-blue-400"
            />
          </div>

          <div className="mt-6 flex justify-end gap-3">
            {/* Kapat Butonu */}
            <button
              onClick={handleClose}
              className="bg-gray-300 hover:bg-gray-400 text-gray-800 px-4 py-2 rounded-md flex items-center gap-x-1 transition-colors duration-200 relative overflow-hidden"
            >
              <span>Kapat</span>
              {/* Mini parlama efekti */}
              <span className="absolute top-0 left-0 w-full h-full pointer-events-none bg-white opacity-0 hover:opacity-10 transition-opacity duration-300 rounded-md"></span>
            </button>
            {/* Kaydet Butonu */}
            <button
              onClick={handleSave}
              className="bg-blue-500 hover:bg-blue-600 text-white px-4 py-2 rounded-md flex items-center gap-x-1 transition-colors duration-200 relative overflow-hidden"
            >
              <span>Kaydet</span>
              {/* Mini parlama efekti */}
              <span className="absolute top-0 left-0 w-full h-full pointer-events-none bg-white opacity-0 hover:opacity-10 transition-opacity duration-300 rounded-md"></span>
            </button>      
            </div> 
        </motion.div>
      </div>
    </AnimatePresence>
  );
}